import { useTranslation } from 'react-i18next'

export interface AddToProductTabBarProps {
  tab: 'content' | 'media'
  onTabChange: (next: 'content' | 'media') => void
}

const TAB_BASE = 'px-4 py-2.5 text-sm transition-colors'
const TAB_ACTIVE =
  'font-semibold text-neutral-900 dark:text-neutral-100 border-b-2 border-orange-500'
const TAB_INACTIVE =
  'text-neutral-500 hover:text-neutral-900 dark:hover:text-neutral-300'

export function AddToProductTabBar({ tab, onTabChange }: AddToProductTabBarProps) {
  const { t } = useTranslation()
  return (
    <div
      role="tablist"
      className="flex items-center border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 px-6"
    >
      <button
        type="button"
        role="tab"
        aria-selected={tab === 'content'}
        onClick={() => onTabChange('content')}
        className={`${TAB_BASE} ${tab === 'content' ? TAB_ACTIVE : TAB_INACTIVE}`}
      >
        {t('addToProduct.tabs.content')}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={tab === 'media'}
        onClick={() => onTabChange('media')}
        className={`${TAB_BASE} ${tab === 'media' ? TAB_ACTIVE : TAB_INACTIVE}`}
      >
        {t('addToProduct.tabs.media')}
      </button>
    </div>
  )
}
